module.exports = __webpack_public_path__ + "media/images/stamp_card-68e696dc89a0283a5f6593121a7f1c8a.png";